'use client'

import Image, { type ImageProps } from 'next/image'
import { type FC } from 'react'

import { storyblokImageLoader } from '../../config'
import { type StoryblokAsset } from '../../storyblok'

interface StoryblokImageProps extends Omit<
  ImageProps,
  'alt' | 'loader' | 'src'
> {
  image: StoryblokAsset
}

export const StoryblokImageComponentHelper: FC<StoryblokImageProps> = ({
  image,
  ...rest
}) =>
  image.filename && (
    <Image
      {...rest}
      alt={image.alt ?? ''}
      loader={storyblokImageLoader}
      src={image.filename}
    />
  )
